<template>
    <div id="page-content-wrapper" class="admin-content-area">
        <template v-if="cantAccessPage === true">
            <div class="container-fluid xyz">
                <div class="page-header-top-container">
                    <div class="page-name color-71aa3f">
                        Case Information
                    </div>
                    <button type="submit" class="btn general-button btn-primary" v-on:click.prevent="backShowCase">Back</button>
                </div>
                <div class="admin-page-content">
                    <div class="row">
                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                            <b-list-group>
                                <template v-for="(customerData , key) in customerArr">
                                    <b-list-group-item>
                                        <div class="row">
                                            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                <strong>Subject : </strong>
                                            </div>
                                            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                <span class="">{{customerData.subject}}</span>
                                            </div>
                                        </div>
                                    </b-list-group-item>
                                    <b-list-group-item>
                                        <div class="row">
                                            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                <strong>Description : </strong>
                                            </div>
                                            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                <span class="">{{customerData.description}}</span>
                                            </div>
                                        </div>
                                    </b-list-group-item>
                                    <b-list-group-item>
                                        <div class="row">
                                            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                <strong>Resolution : </strong>
                                            </div>
                                            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                <span class="">{{customerData.resolution}}</span>
                                            </div>
                                        </div>
                                    </b-list-group-item>
                                    <b-list-group-item>
                                        <div class="row">
                                            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                <strong>Source : </strong>
                                            </div>
                                            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                <span class="">{{formatString(customerData.source)}}</span>
                                            </div>
                                        </div>
                                    </b-list-group-item>
                                    <b-list-group-item>
                                        <div class="row">
                                            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                <strong>Status : </strong>
                                            </div>
                                            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                <span class="">{{formatString(customerData.status)}}</span>
                                            </div>
                                        </div>
                                    </b-list-group-item>
                                    <b-list-group-item>
                                        <div class="row">
                                            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                <strong>Priority : </strong>
                                            </div>
                                            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                <span class="">{{formatString(customerData.priority)}}</span>
                                            </div>
                                        </div>
                                    </b-list-group-item>
                                </template>
                            </b-list-group>
                        </div>
                        <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                            <b-list-group>
                                <template v-for="(customerData , key) in customerArr">
                                    <b-list-group-item>
                                        <div class="row">
                                            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                <strong>Reported On : </strong>
                                            </div>
                                            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                <span class="">{{formatDate(customerData.created_at)}}</span>
                                            </div>
                                        </div>
                                    </b-list-group-item>
                                    <!-- <b-list-group-item>
                                        <div class="row">
                                            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                <strong>Collector : </strong>
                                            </div>
                                            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                <span class="">{{customerData.user_first_name + " " + customerData.user_last_name}}</span>
                                            </div>
                                        </div>
                                    </b-list-group-item> -->
                                    <b-list-group-item>
                                        <div class="row">
                                            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                <strong>Assigned Internal User : </strong>
                                            </div>
                                            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                <span class="">{{customerData.assigned_user_first_name + " " + customerData.assigned_user_last_name}}</span>
                                            </div>
                                        </div>
                                    </b-list-group-item>
                                    <b-list-group-item>
                                        <div class="row">
                                            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                <strong>Related Contact : </strong>
                                            </div>
                                            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                <span class="">{{customerData.contact_first_name + " " + customerData.contact_last_name}}</span>
                                            </div>
                                        </div>
                                    </b-list-group-item>
                                    <b-list-group-item>
                                        <div class="row">
                                            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                <strong>Customer : </strong>
                                            </div>
                                            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                <span class="">{{customerData.customer_firstname}}</span>
                                            </div>
                                        </div>
                                    </b-list-group-item>
                                    <b-list-group-item>
                                        <div class="row">
                                            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                <strong>Dispute Type : </strong>
                                            </div>
                                            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12">
                                                <span class="">{{formatString(customerData.dispute_type)}}</span>
                                            </div>
                                        </div>
                                    </b-list-group-item>
                                </template>
                            </b-list-group>
                        </div>
                    </div>
                </div>
                <template v-if="permission.name == 'can_see_case_comments_list'" v-for="(permission, index) in permissions">
                    <div class="page-header-top-container pt-0">
                        <div id="taskHeader" class="page-name color-71aa3f">
                            Comments
                        </div>
                    </div>
                    <div class="admin-page-content">
                        <div class="forms-container">
                            <div class="row no-margin">
                                <div class="" >
                                    <div class="">
                                        <div class="alert alert-success hide" id="alertSuccess">
                                            <!--<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>-->
                                            <span id="success_messgae"></span>
                                        </div>
                                    </div>
                                </div>
                                <div class="" >
                                    <div class="">
                                        <div class="alert alert-warning hide" id="alertError">
                                            <!--<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>-->
                                            <strong id="errorMsg" class="error"></strong>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                    <div class="list-group" v-if="commentsArr.length > 0">
                                        <template v-for="(commentValue , key) in commentsArr">
                                            <div :key="key"> 
                                                <div class="mb-2 list-group-item">
                                                    <div :class="'view comment_'+commentValue.id">
                                                        <template v-if="permission.name == 'can_add_new_case_comments'" v-for="(permission, index) in permissions">
                                                            <a class="btn edit-btn-vvg waves-effect pull-right" v-if="commentValue.created_by == loginID" v-on:click.prevent="onDeleteComment(commentValue.id,commentValue.message)"><i class="fa fa fa-trash-o"></i></a>
                                                            <a class="btn edit-btn-vvg waves-effect pull-right" v-if="commentValue.created_by == loginID" v-on:click.prevent="onEditComment(commentValue.message, commentValue.id)"><i class="fa fa-pencil-square-o"></i></a>
                                                        </template>
                                                        <h4 class="list-group-item-heading">{{commentValue.first_name + " " + commentValue.last_name}}</h4>
                                                        <p class="list-group-item-text">
                                                            <strong>Message : </strong>{{commentValue.message}}<br>
                                                            <span>{{commentValue.updated_at}}</span>
                                                            <span class="pull-right" v-if="commentValue.updated_by_name != ''">Updated by : {{commentValue.updated_by_name}}</span>
                                                        </p>
                                                    </div> 
                                                    <div style="display: none;" :class="'edit comment_'+commentValue.id"> 
                                                         <label for="comment" id="commenttitle">Edit Comment</label>
                                                        <div class="row">
                                                            <div class="col-sm-12">
                                                                <textarea :name="'comment_'+commentValue.id" :id="'commentData_'+commentValue.id" rows="3"
                                                                    class="form-control no-resize"
                                                                    placeholder="Please type what you want..."
                                                                    v-validate="'required'">{{commentValue.message}}</textarea>

                                                                <span v-show="errors.has('comment_'+commentValue.id)" class="help is-danger" v-if="errors.has('comment_'+commentValue.id)"><font color="red">Comment Required</font></span>
                                                            </div>
                                                            <div class="col-12 mt-2">
                                                                <div class="col-12 paddingleft0">
                                                                    <button type="button" v-on:click="updateComments(commentValue.id,commentValue.message);" class="btn general-button btn-primary">Update</button>
                                                                    <button type="button" v-on:click="onClearEditComment(commentValue.id,commentValue.message);" class="btn general-button btn-danger" data-dismiss="modal">Clear</button>
                                                                    <button type="button" v-on:click="onCancelComment(commentValue.id,commentValue.message)" class="btn general-button btn-secondary" data-dismiss="modal">Cancel</button>
                                                                </div>
                                                            </div>
                                                        </div> 

                                                    </div>
                                                </div> 
                                            </div>
                                        </template>
                                    </div>
                                    <template v-if="permission.name == 'can_add_new_case_comments'" v-for="(permission, index) in permissions">
                                        <label class="mt-3" for="comment" id="commenttitle"><strong>Add Comment</strong></label>
                                        <div class="row">
                                            <div class="col-sm-12">
                                                <textarea name="comment" id="commentData" rows="3"
                                                          class="form-control no-resize"
                                                          placeholder="Please type what you want..."
                                                          v-model="comment"
                                                          v-validate="'required'"></textarea>

                                                <span v-show="errors.has('comment')" class="help is-danger" v-if="errors.has('comment')"><font color="red">Comment Required</font></span>
                                            </div>
                                            <div class="col-12 mt-2">
                                                <div class="col-12 paddingleft0">
                                                    <button type="button" v-on:click="addComments();" class="btn general-button btn-primary" id='addComment'>Add</button>
                                                    <button type="button" v-on:click="onClearComment();" class="btn general-button btn-danger" data-dismiss="modal">Clear</button>  
                                                    <button type="button" v-show="editId != ''" v-on:click="onCancelComment();" class="btn general-button btn-danger" data-dismiss="modal">Cancel</button>
                                                </div>
                                            </div>
                                        </div> 

                                    </template>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
            </div>
        </template>
        <template v-else>
            <div class="admin-page-content">
                <div class="col-md-12 error-detail-main forms-container">
                    <div class="error-template">
                        <h1>Oops!</h1>
                        <h2>403</h2>
                        <div class="error-details">Sorry!, You don't have permission to access this page.</div>
                    </div>
                </div>
            </div>
        </template>
        <app-footer></app-footer>
    </div>   
</template>
<script>
    import Vue from 'vue';
    import FrontFooter from '@/components/partials/FrontFooter';
    import VeeValidate from 'vee-validate';
    import EventBus from '../event-bus';
    import swal from 'sweetalert2/dist/sweetalert2.js';
    import SessioMixin from '../../mixins/sessionmixin';
    const Swal = require('sweetalert2');
    Vue.use(VeeValidate);
    export default {
        name: 'CaseView',
        components: {
            'app-footer': FrontFooter,
        },
        mixins: [SessioMixin],
        data() {
            return{
                isLoggedIn: false,
                permissions: [],
                cantAccessPage: true,
                customerArr: [],
                commentsArr: [],
                comment: '',
                editId: '',
                loginID: 0,
            }
        },
        beforeMount: function () {
            var app = this;
            var check = window.localStorage.getItem('api_token');

            if (check != null) {
                this.isLoggedIn = true;
                app.getPermissions();
            }
        },
        mounted: function () {
            var self = this;
            var path = window.location.pathname;
            var segments = path.split("/");
            $(".removeActive").removeClass('active');
            if (segments[4] != 0) {
                $("#menucustomers").addClass("active");
            } else {
                $("#menucases").addClass('active');
            }
            if (localStorage.getItem("menu_small") == '1') {
                self.menuSmall();
            } else {
                self.menuBig();
            }
            self.showLoader();
            self.loadCase();
            self.showComments();
            var userObj = localStorage.getItem('user_obj');
            if (userObj != null) {
                var userJson = JSON.parse(userObj);
                self.loginID = userJson.id;
                //console.log(self.loginID);
                EventBus.$emit("logged-in", false, userJson["first_name"], userJson["last_name"], userJson["email"]);
            }

        },
        methods: {
            getPermissions: function () {
                var self = this;
                $.ajax({
                    url: process.env.ROOT_API + "/user/permission",
                    type: "POST",
                    headers: {
                        'Accept': 'application/json',
                        "Access-Control-Allow-Origin": '*',
                        "Authorization": "Bearer " + localStorage.getItem("api_token"),
                        'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                        "Cache-Control": "no-cache"
                    },
                    dataType: 'json',
                    success: function (data) {
                        if (data.status == 'success') {
                            self.cantAccessPage = false;
                            self.permissions = data.content;
                            let current_build = window.localStorage.getItem("build_version");
                            let latest_build = data.build;
                            if (current_build != undefined && current_build == '') {
                                localStorage.setItem("build_version", data.build);
                            } else if (current_build != latest_build) {
                                localStorage.setItem("build_version", data.build);
                                location.reload(true);
                            }
                            if (self.permissions.length > 0) {
                                for (var i = 0; i < self.permissions.length; i++) {
                                    if (self.permissions[i].name == 'can_see_case_view') {
                                        self.cantAccessPage = true;
                                    }
                                }
                            }
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.cantAccessPage = false;
                        if (jqXHR.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem('user_obj');
                                localStorage.removeItem('api_token');
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }

                });
            },
            loadCase() {

                var path = window.location.pathname;
                var segments = path.split("/");
                // console.log(segments[3]);
                var self = this;
                $.ajax({
                    url: process.env.ROOT_API + "/case/" + segments[3],
                    type: "GET",
                    headers: {
                        'Accept': 'application/json',
                        "Access-Control-Allow-Origin": '*',
                        "Authorization": "Bearer " + localStorage.getItem("api_token"),
                        'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                        "Cache-Control": "no-cache"
                    },
                    // dataType: 'json',
                    success: function (data) {
                        self.hideLoader();
                        // console.log(data);
                        self.customerArr = data;
                        // console.log(self.customerArr);

                    },
                    error: function (jqXHR, exception) {
                        self.hideLoader();
                        if (jqXHR.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem('user_obj');
                                localStorage.removeItem('api_token');
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }
                });

            },
            backShowCase() {
                var self = this;
                var path = window.location.pathname;
                var segments = path.split("/");
                if (segments[4] != 0) {
                    self.$router.push("/customer/view/" + segments[4]);
                } else {
                    self.$router.push('/case/list');
                }
            },
            addComments() {
                this.$validator.validate().then(result => {
                    if (result) {
                        var path = window.location.pathname;
                        var segments = path.split("/");
                        //console.log(segments[3]);
                        var self = this;
                        self.showLoader();
                        var c_data = $('#commentData').val();

                        $.ajax({
                            url: process.env.ROOT_API + "/comment/create",
                            type: "POST",
                            data: {caseCommentId: self.editId, commentData: c_data, cid: segments[3]},
                            headers: {
                                'Accept': 'application/json',
                                "Access-Control-Allow-Origin": '*',
                                "Authorization": "Bearer " + localStorage.getItem("api_token"),
                                'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                                "Cache-Control": "no-cache"
                            },
                            dataType: 'json',
                            success: function (data) {
                                self.hideLoader();
                                // console.log(data);
                                if (data.status == "success") {
                                    $(".alert-success").parent().parent().addClass('row clearfix');
                                    $(".alert-success").parent().addClass('col-lg-12 col-md-12 col-sm-12 col-xs-12');
                                    $(".alert-success").toggleClass('show');
                                    $("#success_messgae").html('Comment Added Successfully');
                                    setTimeout(function () {
                                        $("#success_messgae").html('');
                                        $('.alert-success').removeClass('show');
                                        $('.alert-success').addClass('hide');
                                        $(".alert-success").parent().parent().removeClass('row clearfix');
                                        $(".alert-success").parent().removeClass('col-lg-12 col-md-12 col-sm-12 col-xs-12');
                                    }, 5000);
                                    self.comment = '';
                                    self.editId = '';
                                    $('#addComment').text('Add');
                                    $('#commenttitle').html('Add Comment');
                                    self.showComments();
                                } else {
                                    if (data.content.length > 0) {
                                        var err = "";
                                        for (var i = 0; i < data.content.length; i++) {
                                            err += data.content[i];
                                        }
                                        $("#errorMsg").html(err);

                                        $(".alert-warning").parent().parent().addClass('row clearfix');
                                        $(".alert-warning").parent().addClass('col-lg-12 col-md-12 col-sm-12 col-xs-12');
                                        $(".alert-warning").toggleClass('show');
                                        setTimeout(function () {
                                            $('.alert-warning').removeClass('show');
                                            $('.alert-warning').addClass('hide');
                                            $(".alert-warning").parent().parent().removeClass('row clearfix');
                                            $(".alert-warning").parent().removeClass('col-lg-12 col-md-12 col-sm-12 col-xs-12');
                                        }, 5000);
                                    }
                                }
                            },
                            error: function (jqXHR, exception) {
                                self.hideLoader();
                                if (jqXHR.status == 0) {
                                    self.error = "Remote server can not be reachable";
                                } else {
                                    //redirect to login page if user not authenticated
                                    if (jqXHR.status == 401) {
                                        //clear previous data
                                        localStorage.removeItem('user_obj');
                                        localStorage.removeItem('api_token');
                                        //EventBus.$emit("logged-in", true, "", "");
                                        self.$router.push("/login");
                                    }
                                    $("#errorMsg").html(jqXHR.responseJSON.message);
                                    $(".alert-warning").parent().parent().addClass('row clearfix');
                                    $(".alert-warning").parent().addClass('col-lg-12 col-md-12 col-sm-12 col-xs-12');
                                    $(".alert-warning").toggleClass('show');
                                    setTimeout(function () {
                                        $('.alert-warning').removeClass('show');
                                        $('.alert-warning').addClass('hide');
                                        $(".alert-warning").parent().parent().removeClass('row clearfix');
                                        $(".alert-warning").parent().removeClass('col-lg-12 col-md-12 col-sm-12 col-xs-12');
                                    }, 5000);
                                }
                            }
                        });
                    }
                });
            },
            updateComments(id, message) {
                var path = window.location.pathname;
                var segments = path.split("/");
                //console.log(segments[3]);
                var self = this;
                self.showLoader();
                var c_data = $('#commentData_' + id).val();

                $.ajax({
                    url: process.env.ROOT_API + "/comment/create",
                    type: "POST",
                    data: {caseCommentId: id, commentData: c_data, cid: segments[3]},
                    headers: {
                        'Accept': 'application/json',
                        "Access-Control-Allow-Origin": '*',
                        "Authorization": "Bearer " + localStorage.getItem("api_token"),
                        'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                        "Cache-Control": "no-cache"
                    },
                    dataType: 'json',
                    success: function (data) {
                        $('.view.comment_' + id).show();
                        $('.edit.comment_' + id).hide();
                        self.hideLoader();
                        // console.log(data);
                        if (data.status == "success") {
                            $(".alert-success").parent().parent().addClass('row clearfix');
                            $(".alert-success").parent().addClass('col-lg-12 col-md-12 col-sm-12 col-xs-12');
                            $(".alert-success").toggleClass('show');
                            $("#success_messgae").html('Comment Updated Successfully');
                            setTimeout(function () {
                                $("#success_messgae").html('');
                                $('.alert-success').removeClass('show');
                                $('.alert-success').addClass('hide');
                                $(".alert-success").parent().parent().removeClass('row clearfix');
                                $(".alert-success").parent().removeClass('col-lg-12 col-md-12 col-sm-12 col-xs-12');
                            }, 5000);
                            self.comment = '';
                            self.editId = '';
                            $('#addComment').text('Add');
                            $('#commenttitle').html('Add Comment');
                            self.showComments();
                        } else {
                            $('#commentData_' + id).val('' + message);
                            if (data.content.length > 0) {
                                var err = "";
                                for (var i = 0; i < data.content.length; i++) {
                                    err += data.content[i];
                                }
                                $("#errorMsg").html(err);

                                $(".alert-warning").parent().parent().addClass('row clearfix');
                                $(".alert-warning").parent().addClass('col-lg-12 col-md-12 col-sm-12 col-xs-12');
                                $(".alert-warning").toggleClass('show');
                                setTimeout(function () {
                                    $('.alert-warning').removeClass('show');
                                    $('.alert-warning').addClass('hide');
                                    $(".alert-warning").parent().parent().removeClass('row clearfix');
                                    $(".alert-warning").parent().removeClass('col-lg-12 col-md-12 col-sm-12 col-xs-12');
                                }, 5000);
                            }
                        }
                    },
                    error: function (jqXHR, exception) {
                        $('#commentData_' + id).val('' + message);
                        $('.view.comment_' + id).show();
                        $('.edit.comment_' + id).hide();
                        self.hideLoader();
                        if (jqXHR.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem('user_obj');
                                localStorage.removeItem('api_token');
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }
                            $("#errorMsg").html(jqXHR.responseJSON.message);
                            $(".alert-warning").parent().parent().addClass('row clearfix');
                            $(".alert-warning").parent().addClass('col-lg-12 col-md-12 col-sm-12 col-xs-12');
                            $(".alert-warning").toggleClass('show');
                            setTimeout(function () {
                                $('.alert-warning').removeClass('show');
                                $('.alert-warning').addClass('hide');
                                $(".alert-warning").parent().parent().removeClass('row clearfix');
                                $(".alert-warning").parent().removeClass('col-lg-12 col-md-12 col-sm-12 col-xs-12');
                            }, 5000);
                        }
                    }
                });

            },
            showComments() {
                var self = this;
                var path = window.location.pathname;
                var segments = path.split("/");
                $.ajax({
                    url: process.env.ROOT_API + "/listcomment/" + segments[3],
                    type: "GET",
                    headers: {
                        'Accept': 'application/json',
                        "Access-Control-Allow-Origin": '*',
                        "Authorization": "Bearer " + localStorage.getItem("api_token"),
                        'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                        "Cache-Control": "no-cache"
                    },

                    data: {
                        case_id: segments[3]
                    },
                    // dataType: 'json',
                    success: function (data) {
                        // console.log(data);
                        self.hideLoader();
                        self.commentsArr = data.content;
                        // console.log(self.commentsArr);
                    },
                    error: function (jqXHR, exception) {
                        self.hideLoader();
                        if (jqXHR.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (jqXHR.status == 401) {
                                //clear previous data
                                localStorage.removeItem('user_obj');
                                localStorage.removeItem('api_token');
                                //EventBus.$emit("logged-in", true, "", "");
                                self.$router.push("/login");
                            }
                            self.error = jqXHR.responseJSON.message;
                        }
                    }
                });
            },
            onDeleteComment(id, message) {
                $('.comment_' + id).parent().css({"border": "1px solid #FF0000"});
                var self = this;
                /*if (confirm('Are you sure that you want to delete this Comment! "' + message + '"')) {*/
                Swal.fire({
                    title: 'Are you sure?',
                    text: "wan't to delete this Comment!",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, delete it!'
                }).then((result) => {
                    $('.comment_' + id).parent().removeAttr("style");
                    if (result.value) {
                        Swal.fire(
                                'Deleted!',
                                'Comment has been deleted.',
                                'success'
                                )
                        $.ajax({
                            url: process.env.ROOT_API + "/comment/delete/" + id,
                            type: "POST",
                            headers: {
                                'Accept': 'application/json',
                                "Access-Control-Allow-Origin": '*',
                                "Authorization": "Bearer " + localStorage.getItem("api_token"),
                                'Access-Control-Allow-Headers': 'Origin, Content-Type, Authorization,X-Requested-With',
                                "Cache-Control": "no-cache"
                            },
                            // dataType: 'json',
                            success: function (data) {
                                //console.log(data);
                                //self.onCancelComment();
                                self.showComments();
                            },
                            error: function (jqXHR, exception) {
                                if (jqXHR.status == 0) {
                                    self.error = "Remote server can not be reachable";
                                } else {
                                    //redirect to login page if user not authenticated
                                    if (jqXHR.status == 401) {
                                        //clear previous data
                                        localStorage.removeItem('user_obj');
                                        localStorage.removeItem('api_token');
                                        //EventBus.$emit("logged-in", true, "", "");
                                        self.$router.push("/login");
                                    }
                                    self.error = jqXHR.responseJSON.message;
                                }
                            }
                        });
                    }
                })
                /*}*/
            },
            onEditComment(message, id) {
                var self = this;
                $('.view.comment_' + id).hide();
                $('.edit.comment_' + id).show();
                $('#commentData_' + id).val(message);
                /*self.comment = message;
                 self.editId = id;
                 $('#addComment').text('Update');
                 $('#commenttitle').html('Update Comment');*/

            },
            /*onEditComment(message, id) {
             var self = this;
             self.comment = message;
             self.editId = id;
             $('#addComment').text('Update');
             $('#commenttitle').html('Update Comment');
             },*/
            onClearComment() {
                var self = this;
                self.comment = '';
                if (self.editId != '') {
                    $('#addComment').text('Update');
                    $('#commenttitle').html('Update Comment');
                } else {
                    $('#addComment').text('Add');
                    $('#commenttitle').html('Add Comment');
                }
                $(".error").html("");
            },
            onClearEditComment(id) {
                $('#commentData_' + id).val('');
            },
            onCancelComment(id, message) {
                var self = this;
                $('#commentData_' + id).val('' + message);
                $('.view.comment_' + id).show();
                $('.edit.comment_' + id).hide();
            },
            /*onCancelComment() {
             var self = this;
             self.comment = '';
             self.editId = '';
             $('#addComment').text('Add');
             $('#commenttitle').html('Add Comment');
             $(".error").html("");
             },*/
            formatString(data) {
                if (typeof (data) != 'undefined') {
                    var self = this;
                    var value = data.replace(/_/g, " ");
                    var upp = value.toLowerCase().replace(/\b[a-z]/g, function (letter) {
                        return letter.toUpperCase();
                    });
                    return upp;
                } else {
                    return false;
                }
            },
            formatDate(date) {
                if (typeof (date) != 'undefined') {
                    date = date.split(" ");
                    date = date[0];
                    var d = new Date(date);
                    var month = '' + (d.getMonth() + 1);
                    var day = '' + d.getDate();
                    var year = d.getFullYear();
                    if (month.length < 2)
                        month = '0' + month;
                    if (day.length < 2)
                        day = '0' + day;
                    return [month, day, year].join('/');
                } else {
                    return false;
                }
            },
            menuSmall: function () {
                $('.opensidebar').show();
                $('.closesidebar').hide();
                $('.menu').addClass('menusmall');
                $('.sidemenu li a span,.legal').addClass('displaynone');
                $('.sidemenu li a i').addClass('displayicons');
                $('.sidebar').css({width: "70px"});
                $('.content').css({marginLeft: "70px"});
                $("html, body").animate({scrollTop: 0}, 10);
            },
            menuBig: function () {
                $('.opensidebar').hide();
                $('.closesidebar').show();
                $('.menu').removeClass('menusmall');
                $('.sidemenu li a span,.legal').removeClass('displaynone');
                $('.sidemenu li a i').removeClass('displayicons');
                $('.sidebar').css({width: "260px"});
                $('.content').css({marginLeft: "260px"});
                $("html, body").animate({scrollTop: 0}, 10);
            }

        }
    }
</script>



// WEBPACK FOOTER //
// src/components/cases/CaseView.vue